import gql from 'graphql-tag';

export const GET_LENDER_PROFILE_ASSIGNMENT_TITLES = gql`
  query GetLenderProfileAssignmentTitles($lenderProfileId: ID!) {
    lenderProfileAssignmentTitles(lenderProfileId: $lenderProfileId) {
      lenderProfileAssignmentTitleId
      lenderProfileId
      userProfileId
      title
    }
  }
`;
